<template>
  <div class="idea-item col-sm-12" :class="{'edit-mode': editMode}">
    <div class="idea-menu-icon" v-if="!editMode">
      <b-dropdown
        variant="link"
        right
        text="Right align"
        toggle-class="text-decoration-none"
        no-caret
        lazy
      >
        <template v-slot:button-content>
          <span class="icon-three-dots"></span>
        </template>
        <b-dropdown-item>
          <span class="publishItem" @click="publishIdea()">Publish idea</span>
        </b-dropdown-item>
        <b-dropdown-item>
          <span class="deleteItem" @click="deleteIdea()">Delete</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="close-icon" @click="close" v-if="editMode">
      <i class="icon-close"></i>
    </div>
    <div class="title">
      <div v-if="!editMode">
        <text-expandable
          :text="idea.title"
          @textClicked="editIdea()"
        ></text-expandable>
      </div>
      <textarea
        ref="contentTextArea"
        v-if="editMode"
        v-model="idea.title"
        @input="mixin_autoResize_resize"
        @focus="mixin_autoResize_resize"
        @keyup.enter.ctrl="editIdea()"
        autofocus
      />
      <div class="categories" v-if="!editMode && categories.length">
        <span class="category" v-for="(category, index) in categories" :key="index"> {{category}} </span>
      </div>
      <div class="action-bar"  v-if="editMode">
        <category-filter label="Add category" v-model="updatedCategories" :initialCategories="initialCategories"></category-filter>
        <accent-button title="Save" :act="editIdea"></accent-button>
      </div>
    </div>
    
  </div>
</template>

<script>
import bus from "../bus";
import api from "../api";
import mixinAutoResize from "../mixins/autoResize.js";

import TextExpandable from "./shared/TextExpandable.vue";
import CategoryFilter from "./ideas/CategoryFilter.vue";
import AccentButton from "./shared/AccentButton.vue"

import updateIdea from "../gql/ideas/updateIdea.gql";
import deleteIdea from "../gql/ideas/deleteIdea.gql";
import createIdeaCategories from "../gql/categories/createIdeaCategories.gql"
import deleteIdeaCategories from "../gql/categories/deleteIdeaCategories.gql"

export default {
  components: {
    TextExpandable,
    CategoryFilter,
    AccentButton
  },
  data() {
    return {
      editMode: false,
      initialCategories: [],
      updatedCategories: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    categories() {
      return this.idea.categories ? this.idea.categories.map(elem => elem.category.label) : [];
    }
  },
  methods: {
    deleteIdea: function () {
      const id = this.idea.id;

      this.$apollo
        .mutate({
          mutation: deleteIdea,
          variables: {
            id,
          },
        })
        .then(() => {
          api.createEventTracking(
            "idea-deleted-private",
            "idea-deleted",
            this.user.id,
            true
          );
          bus.$emit('update-ideas');
        })
        .catch(function (error) {
          this.$rollbar.error(error);
          alert("Could not remove the idea. Please try again later");
        });
    },
    editIdea: function () {
      if (this.editMode) {
        const id = this.idea.id;
        const title = this.idea.title;

        this.$apollo
          .mutate({
            mutation: updateIdea,
            variables: {
              id,
              title,
            },
          })
          .then((data) => {
            this.saveCategories(data.data.update_ideas_by_pk.id)
          })
          .catch(function (error) {
            this.$rollbar.error(error);
            alert("Could not update the idea. Please try again later");
          });
        this.editMode = !this.editMode;
      } else {
        this.initialCategories = JSON.parse(JSON.stringify(this.idea.categories.map(x => x.category.id)));
        this.editMode = !this.editMode;
        setTimeout(() => {
          this.$refs.contentTextArea.focus();
        });
      }
    },
    publishIdea: function () {
      bus.$emit("open-modal", "PublishIdeaModal", "idea", this.idea);
    },
    saveCategories: function(ideaId) {
      let toBeRemoved = this.idea.categories.filter(x => !this.updatedCategories.map(x => x.id).includes(x.category.id));
      let toBeAdded = this.updatedCategories.filter(x => !this.idea.categories.map(x => x.category.id).includes(x.id));
      for(let i=0; i<toBeAdded.length; i++) {
        const categoryId = toBeAdded[i].id;
        this.$apollo
          .mutate({
            mutation: createIdeaCategories,
            variables: {
              ideaId,
              categoryId
            }
          }).then(() => {
            bus.$emit('update-ideas');
          });
      }
      for(let i=0; i<toBeRemoved.length; i++) {
        const categoryId = toBeRemoved[i].category.id;
        this.$apollo
          .mutate({
            mutation: deleteIdeaCategories,
            variables: {
              ideaId,
              categoryId
            }
          }).then(() => {
            bus.$emit('update-ideas');
          });
      }
    },
    close: function () {
      this.editMode = false;
    },
  },
  props: {
    idea: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  mixins: [mixinAutoResize],
};
</script>

<style lang="scss" scoped>
@use '../styles/theme.scss';

.idea-item,
.idea-item.col-sm-12 {
  border: 0px;
  padding: 0;
}

.idea-item .marker,
.idea-item .content {
  display: inline-block;
}

.idea-item div.title {
  background-color: theme.$white-background;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid theme.$accent-color;
  border-radius: 4px;
  text-align: left;
  padding: 16px 12px;
  box-sizing: content-box;
  font-size: 14px;
  word-break: break-word;
}

.idea-item div.title textarea {
  background-color: theme.$white-background;
  width: calc(100% - 36px);
  height: 1em;
  margin: 0px;
  padding: 0px;
  border: none;
  outline: none;
  min-height: 1em;
  max-height: 180px;
  resize: vertical;
}

.idea-item div.idea-menu-icon {
  position: absolute;
  right: 0px;
  top: 8px;
}

.deleteItem {
  color: theme.$text-danger !important;
}

.idea-menu-icon .btn-group > .btn:focus,
.idea-menu-icon .btn-group > .btn:hover {
  z-index: 0;
}

.idea-item span.icon-three-dots {
  color: theme.$text-secondary-color;
  font-size: 24px;
}

.categories {
  margin-top: 8px;
  font-size: 12px;
  color: theme.$text-secondary-color;
  font-weight: 600;
}

.categories .category {
  background-color: theme.$light-background; 
  margin-right: 4px;
  padding: 4px 6px;
  border-radius: 4px;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
}
.action-bar .accent-button {
  align-self: flex-start;
}

.close-icon {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 6px 12px;
  font-size: 20px;
}
</style>